import { CircularProgress } from '@material-ui/core';
import * as React from 'react';

const spinnerStyle = {
    alignItems: 'center' as any,
    display: 'flex',
    flex: '1 1 auto',
    justifyContent: 'center' as any,
    minHeight: '400px'
};

const DEFAULT_SPINNER_SIZE = 30;

const Spinner: React.FC<{ size?: number }> = ({ size = DEFAULT_SPINNER_SIZE }) => (
    <div style={spinnerStyle}>
        <CircularProgress size={size} />
    </div>
);

export { Spinner };
